import styled from "styled-components";
import { NavLink as router } from "react-router-dom";

export const ContentConfig = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
`;

export const ListConfig = styled.div`
  animation: animeTop 0.3s forwards;
  border-radius: 5px;
  opacity: 0;
  position: absolute;
  right: 10px;
  top: 90px;
  z-index: 3002;

  transform: translateY(-20px);
  @media (max-width: 600px) {
    top: 105px;
    width: 100%;
    right: 0;
    padding: 0 10px;
  }

  @keyframes animeTop {
    to {
      opacity: 1;
      transform: initial;
    }
  }
`;

export const Title = styled.h1`
  align-items: center;
  border-bottom: solid 1px #eeeeee;
  color: #000;
  display: flex;
  padding: 16px 24px;
  &:hover {
    background: #f3f3f3;
  }
`;

export const List = styled.ul`
  background-color: var(--secondary);
  border-radius: 3px;
  display: flex;
  flex-direction: column;
`;

export const Item = styled(router)`
  border-bottom: 1px solid #eee;
  border-radius: 3px;
  color: #ffffff;
  cursor: pointer;
  font-size: 1.4rem;
  padding: 15px 20px;
  text-align: center;
  text-decoration: none;
  &:last-child {
    border-bottom: none;
  }
  &:hover {
    background: linear-gradient(
      to left,
      #d9dff8,
      #e4e7fa,
      #eeeefb,
      #f7f7fd,
      #f2f2f2
    );
    color: #000;
  }
`;

export const CleanNotification = styled.div`
  border-top: solid 1px #eeeeee;
  display: flex;
  justify-content: center;
  padding: 10px 0px;
  width: 100%;
`;

export const ButtonCleanNotification = styled.button`
  background: transparent;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 1.4rem;
  padding: 5px;
  transition: 0.3s ease;
  text-transform: uppercase;
`;
